export default __webpack_public_path__ + "static/almonit-1f22cde96676687223e41737a9571eb9.png";